export const formatCurrency = ({ amount, locale = 'en-GB', currency = 'aud' }) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const formattedAmount = formatter.format(amount);

  return formattedAmount;
};
